const module = { name: 'shared/seatMap/accessibility', exports: {} }; const exports = module.exports;



const getSeatCoords = element => ({
    x: +element.dataset.x || 0,
    y: +element.dataset.y || 0
})
function navigation(renderElement, elements, onSelection) {
    if (!elements || !onSelection || elements.length === 0) {
        return null;
    }
    const items = Array.from(elements);
    let currentIndex = 0;
    items.sort((a, b) => {
        const aCoords = getSeatCoords(a);
        const bCoords = getSeatCoords(b);
        if (Math.abs(aCoords.y - bCoords.y) < 20) {
            return aCoords.x - bCoords.x;
        }
        return aCoords.y - bCoords.y;
    });
    renderElement.querySelectorAll('.smp__seat').forEach((seat) => {
        seat.setAttribute('tabindex', seat.classList.contains('smp__seat--selected') ? '0' : '-1');
    });
    items.forEach((item, index) => {
        item.setAttribute('tabindex', index === 0 ? '0' : '-1');
        item.addEventListener('keydown', handleKeydown);
        item.addEventListener('focus', handleFocus);
    });
    function handleFocus(event) {
        currentIndex = items.indexOf(event.currentTarget);
    }
    function handleKeydown(event) {
        const currentItem = items[currentIndex];
        let targetIndex = currentIndex;
        switch (event.key) {
            case 'ArrowUp':
                targetIndex = findItemInDirection('up');
                break;
            case 'ArrowDown':
                targetIndex = findItemInDirection('down');
                break;
            case 'ArrowLeft':
                targetIndex = findItemInDirection('left');
                break;
            case 'ArrowRight':
                targetIndex = findItemInDirection('right');
                break;
            case 'Enter':
            case 'Space':
                event.preventDefault();
                onSelection(currentItem, currentIndex);
                return;
            case 'Home':
                event.preventDefault();
                targetIndex = 0;
                break;
            case 'End':
                event.preventDefault();
                targetIndex = items.length - 1;
                break;
            default:
                return;
        }
        if (targetIndex !== currentIndex && targetIndex >= 0 && targetIndex < items.length) {
            event.preventDefault();
            moveFocus(currentIndex, targetIndex);
        }
    }
    function findItemInDirection(direction) {
        const currentItem = items[currentIndex];
        const currentCoords = getSeatCoords(currentItem);
        let bestIndex = currentIndex;
        let bestDistance = Infinity;
        items.forEach((item, index) => {
            if (index === currentIndex) {
                return;
            }
            const itemCoords = getSeatCoords(item);
            let isValidDirection = false;
            let distance = 0;
            switch (direction) {
                case 'up':
                    if (itemCoords.y < currentCoords.y - 10) {
                        isValidDirection = true;
                        distance = Math.abs(itemCoords.x - currentCoords.x) + (currentCoords.y - itemCoords.y) * 0.1;
                    }
                    break;
                case 'down':
                    if (itemCoords.y > currentCoords.y + 10) {
                        isValidDirection = true;
                        distance = Math.abs(itemCoords.x - currentCoords.x) + (itemCoords.y - currentCoords.y) * 0.1;
                    }
                    break;
                case 'left':
                    if (itemCoords.x < currentCoords.x - 10) {
                        isValidDirection = true;
                        distance = Math.abs(itemCoords.y - currentCoords.y) + (currentCoords.x - itemCoords.x) * 0.1;
                    }
                    break;
                case 'right':
                    if (itemCoords.x > currentCoords.x + 10) {
                        isValidDirection = true;
                        distance = Math.abs(itemCoords.y - currentCoords.y) + (itemCoords.x - currentCoords.x) * 0.1;
                    }
                    break;
            }
            if (isValidDirection && distance < bestDistance) {
                bestDistance = distance;
                bestIndex = index;
            }
        });
        return bestIndex;
    }
    function moveFocus(fromIndex, toIndex) {
        const fromItem = items[fromIndex];
        const toItem = items[toIndex];
        fromItem.setAttribute('tabindex', '-1');
        toItem.setAttribute('tabindex', '0');
        toItem.focus();
        currentIndex = toIndex;
    }
    return function cleanup() {
        items.forEach((item) => {
            item.removeEventListener('keydown', handleKeydown);
            item.removeEventListener('focus', handleFocus);
        });
    };
}
function zoom(content, zoomFactor) {
    if (zoomFactor === 1) {
        resetZoom(content);
        return;
    }
    let scrollWrapper = content._zoomScrollWrapper;
    if (!scrollWrapper) {
        scrollWrapper = document.createElement('div');
        scrollWrapper.style.position = 'absolute';
        scrollWrapper.style.top = '0';
        scrollWrapper.style.left = '0';
        scrollWrapper.style.right = '0';
        scrollWrapper.style.bottom = '0';
        scrollWrapper.style.paddingTop = `0`;
        scrollWrapper.style.paddingBottom = `0`;
        scrollWrapper.style.overflow = 'auto';
        scrollWrapper.style.cursor = 'grab';
        content._originalParent = content.parentNode;
        content._originalNextSibling = content.nextSibling;
        content._originalParent.insertBefore(scrollWrapper, content);
        scrollWrapper.appendChild(content);
        content._zoomScrollWrapper = scrollWrapper;
    }
    setupContentScaling(content, scrollWrapper, zoomFactor);
    setupZoomMouseEvents(scrollWrapper);
}
function setupContentScaling(content, scrollWrapper, zoomFactor) {
    content.style.transform = `scale(${zoomFactor})`;
    content.style.transformOrigin = 'top left';
    const contentWidth = content.offsetWidth;
    const wrapperWidth = scrollWrapper.clientWidth;
    const scaledWidth = contentWidth * zoomFactor;
    const sidePadding = scaledWidth <= wrapperWidth ? (wrapperWidth - scaledWidth) / 2 : 0;
    scrollWrapper.style.paddingRight = `${sidePadding}px`;
    scrollWrapper.style.paddingLeft = `${sidePadding}px`;
    scrollWrapper.scrollTop = 0;
    if (scaledWidth <= wrapperWidth) {
        scrollWrapper.scrollLeft = 0;
    }
    else {
        scrollWrapper.scrollLeft = (scaledWidth - wrapperWidth) / 2;
    }
}
function setupZoomMouseEvents(scrollWrapper) {
    if (scrollWrapper.dataset.dragScrollEnabled) {
        return;
    }
    scrollWrapper.dataset.dragScrollEnabled = 'true';
    let isClicking = false;
    let startX;
    let startY;
    let scrollLeft;
    let scrollTop;
    const handleMouseDown = (e) => {
        isClicking = true;
        scrollWrapper.style.cursor = 'grabbing';
        startX = e.pageX - scrollWrapper.offsetLeft;
        startY = e.pageY - scrollWrapper.offsetTop;
        scrollLeft = scrollWrapper.scrollLeft;
        scrollTop = scrollWrapper.scrollTop;
    };
    const handleMouseLeave = () => {
        isClicking = false;
        scrollWrapper.style.cursor = 'grab';
    };
    const handleMouseUp = () => {
        isClicking = false;
        scrollWrapper.style.cursor = 'grab';
    };
    const handleMouseMove = (e) => {
        if (!isClicking) {
            return;
        }
        e.preventDefault();
        const x = e.pageX - scrollWrapper.offsetLeft;
        const y = e.pageY - scrollWrapper.offsetTop;
        const scrollX = (x - startX);
        const scrollY = (y - startY);
        scrollWrapper.scrollLeft = scrollLeft - scrollX;
        scrollWrapper.scrollTop = scrollTop - scrollY;
    };
    scrollWrapper._zoomListeners = {
        mousedown: handleMouseDown,
        mouseleave: handleMouseLeave,
        mouseup: handleMouseUp,
        mousemove: handleMouseMove
    };
    scrollWrapper.addEventListener('mousedown', handleMouseDown);
    scrollWrapper.addEventListener('mouseleave', handleMouseLeave);
    scrollWrapper.addEventListener('mouseup', handleMouseUp);
    scrollWrapper.addEventListener('mousemove', handleMouseMove);
}
function resetZoom(content) {
    content.style.transform = '';
    content.style.transformOrigin = '';
    const scrollWrapper = content._zoomScrollWrapper;
    if (scrollWrapper) {
        if (scrollWrapper._zoomListeners) {
            const listeners = scrollWrapper._zoomListeners;
            scrollWrapper.removeEventListener('mousedown', listeners.mousedown);
            scrollWrapper.removeEventListener('mouseleave', listeners.mouseleave);
            scrollWrapper.removeEventListener('mouseup', listeners.mouseup);
            scrollWrapper.removeEventListener('mousemove', listeners.mousemove);
            delete scrollWrapper._zoomListeners;
        }
        if (content._originalNextSibling) {
            content._originalParent.insertBefore(content, content._originalNextSibling);
        }
        else {
            content._originalParent.appendChild(content);
        }
        scrollWrapper.remove();
        delete content._zoomScrollWrapper;
        delete content._originalParent;
        delete content._originalNextSibling;
    }
}
module.exports = {
    navigation,
    zoom,
};
export default module.exports;